import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import LearnGame from "../../components/LearnGame";
import PracticeGame from "../../components/PracticeGame";
import KeyboardStage3 from "../../components/KeyboardStage3";
import Keyboard from "../../components/Keyboard";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useSpeech from "../../hooks/useSpeech";
import { Scale } from 'react-scaling';
import { Textfit } from 'react-textfit';
import axios from "axios";
//import useAuth from "../../../auth/hooks/useAuth";

var { questions } = [];

export default function Game({ ...props }) {
   // const { state: authState } = useAuth();
    const [loading, setLoading] = useState(true);
    const [correctQuestions, setCorrectQuestions] = useState([]);
    const [incorrectQuestions, setIncorrectQuestions] = useState([]);
    const [score, setScore] = useState(0);
    const [combo, setCombo] = useState(0);
    const [maxCombo, setMaxCombo] = useState(0);
    const [feedback, setFeedback] = useState([]);
    const [nofeedback, setNoFeedback] = useState([]);
    const [status, setStatus] = useState("LOADING");
    const [setup, setSetup] = useState(false);
    const [custom, setCustom] = useState(false);
    const [waitTime, setWaitTime] = useState(-10);

    const[showColouredFeedback, setColouredFeedback] = useState(false);

    const [refresh, setRefresh] = useState(false)
    //const {useTop} = useTopicQuestions();
    //console.log(loading);

    var timer = -1;
    if(props.timelimit > 0)
    {
        timer = props.timelimit;
    }
    else
    {
        timer = 240;
    }

    var questionMax = -1;
    if(props.minimum > 0)
    {
        questionMax = props.minimum;
    }

    function shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
      }

    //console.log(props);
    if (setup == false) {
        questions = undefined;
        if (questions == undefined && props.customlist == undefined && setup == false) {
            var params = {
                topics: props.topics,
                game_type: "spelling"
            };
            try {
                (async () => {
                    const response = await axios({
                        method: "get",
                        url: `${process.env.REACT_APP_OAUTH_URL}/lite/topics/questions`,
                        params
                    });
                    setStatus("OK");
                    console.log(response.data);
                    questions = response.data;
                })();
            } catch (e) {
                setStatus("ERROR");
            }
            setCustom(false);
            setSetup(true);
            //newQuestion();
        } else if (setup == false && props.customlist != undefined) {
            questions = [];
            var list = props.customlist;
            list.forEach(q => {
                var reg = new RegExp("\\b" + q.word + "\\b", 'i');
                let questionText = q.question.replace(reg, "$");//do replacement thing
                let qobj = { "question_key": q.id, "sentence": questionText, "word": q.word, "topic_key": q.id, "topic_id": q.id }
                questions.push(qobj);
            });
            setStatus("OK");
            setCustom(true);
            setSetup(true);
        }
    }

    const [currentQuestion, setCurrentQuestion] = useState([]);
    const [wordToSay, setWordToSay] = useState("");
    const [extraChars, setExtraChars] = useState([]);
//NEW VARIABLES
    const[qnum, setQuestionNumber] = useState(-1);
    const [completedQuestions, setCompletedQuestions] = useState([]);
    const [wrongQuestions, setWrongQuestions] = useState([]);
    const [round, setRound] = useState(1);
    const [showWord, setShowWord] = useState(true);//whether to show the word or not
    const [wordTimer, setWordTimer] = useState(-10);//timer to hide the word
    const [showCompleteScreen, setShowCompleteScreen] = useState(false);//shows some round complete screen after each round

    const [inputLetters, setInputLetters] = useState([]);//this is an array of letters, it will have values of answer: and value:, when a new question is created it will create a blank array of it


    //timer for showing the word
    useEffect(() => {
        if (wordTimer > 0) {
            var wordtimerID = setInterval(() => reduceWordTimer(), 1000);
            return () => {
                clearInterval(wordtimerID);
            };
        } else if (wordTimer != -10) {
            setShowWord(false);
        }
      },[wordTimer]);

      function reduceWordTimer() {
        console.log(wordTimer);
        setWordTimer(wordTimer - 1);
      }

    function newQuestion() {
        console.log("new question");
        let tqnum = qnum+1;
        setQuestionNumber(tqnum);
        //setQuestionNumber(tqnum);
        //needs a better check for when you have answered up to questions.length but don't have them all right, needs to go back and go to the first question that isn't included in teh completedquestions array
        //use effects to generate new question by generating a new question whenever tqnum changes?
    }

    useEffect(() => {
        console.log("qnum changed");
        if (status == "OK"){
                //check if completed already then increment again if completed already until greater than questions.length
                console.log("comparing lengths");
                console.log(qnum)
                console.log(questions.length);
            if (qnum < questions.length){
                if (completedQuestions.includes(questions[qnum].word)){
                    console.log("completed questions contains it");
                    newQuestion();
                }else{
                    var sample = questions[qnum];
                    sample.answers = [];
                    sample.answers.push({correct: true, value: sample.word});
                    sample.answers.push({correct: false, value: sample.wrong_answer_1, });
                    sample.answers.push({correct: false, value: sample.wrong_answer_2, });
                    sample.answers.push({correct: false, value: sample.wrong_answer_3, });

                    sample.answers = shuffleArray(sample.answers);

                    //ROUND 2
                    if (round == 2){
                      var letters = currentQuestion.word.split('');
                      let letterValues = [];
                      for (let i = 0; i < letters.length; i++) {
                        letterValues.push({answer: letters[i], value: ""});
                      }
                      setInputLetters(letterValues);
                    }

                    //SHOW WORD
                    if (round == 1){
                        setShowWord(true);
                        setWordTimer(4);
                    }else if (round == 2){
                      setShowWord(true);
                      setWordTimer(4);
                    }else if (round == 3){
                      setShowWord(true);
                      setWordTimer(2);
                    }

                    setCurrentQuestion(sample);
                    //check if wrong 6 times
                    console.log("COMPELTED:");
                    console.log(completedQuestions);
                    console.log("WRONG:");
                    console.log(wrongQuestions);
                     let wrongCount = 0;
                     for (let i = 0; i < wrongQuestions.length; i++) {
                       if (sample.word ==  wrongQuestions[i]){
                         wrongCount++;
                       }
                     }
                     console.log(wrongCount);
                     if (wrongCount >= 6){
                      setCompletedQuestions([...completedQuestions, sample.word]);
                     }
                }
            }
            else{
                console.log("qnum is greater");
                setQuestionNumber(0);
            }
        }
    }, [qnum]);

    useEffect(() => {
        if (status == "OK"){
            if (completedQuestions.length != questions.length){
                newQuestion();
            }else{
                CheckRoundSystem();
            }
        }
    }, [completedQuestions]);

    

    //will check if each question is completed of that round, otherwise populate the question list with ones not correct yet
    function CheckRoundSystem(){
        console.log("checking round system");
        console.log(completedQuestions);
        console.log(questions);
        if (completedQuestions.length == questions.length){
            //next round
            setShowCompleteScreen(true);
            
        }else{
            //setQuestionNumber(0);
            newQuestion();
        }
    }

    function NextRound(){
            setShowCompleteScreen(false);
            setCompletedQuestions([]);//blank this array
            setWrongQuestions([]);
            setRound(round+1);
            console.log("ROUND COMPLETED");
            console.log(round);
            //setQuestionNumber(0);
    }

    function getExtraChars(word, level) {
        let alphabet = [
            "a",
            "b",
            "c",
            "d",
            "e",
            "f",
            "g",
            "h",
            "i",
            "j",
            "k",
            "l",
            "m",
            "n",
            "o",
            "p",
            "q",
            "r",
            "s",
            "t",
            "u",
            "v",
            "w",
            "x",
            "y",
            "z"
        ];

        return alphabet;
    }

    async function checkResult(value, callback) {
        let isCorrect = true;
        if (value) {
            if (currentQuestion.word.toLowerCase() === value.toLowerCase()) {
                setCorrectQuestions([...correctQuestions, currentQuestion]);
                isCorrect = true;
                let multiplier = combo > 0 ? combo + 1 : 1;
                multiplier = multiplier > 5 ? 5 : multiplier;
                setScore(score + multiplier * 10);
                setCombo(combo + 1);
                if (combo > maxCombo) {
                    setMaxCombo(combo);
                }
                let result = {
                    question: currentQuestion.sentence.replace("$", " _ "),
                    correct: currentQuestion.word,
                    incorrect: value
                };
                setNoFeedback([...nofeedback, result]);
            } else {
                setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
                isCorrect = false;
                if (combo === 0 && score >= 10) {
                    setScore(score - 10);
                } else {
                    setCombo(0);
                }
                let result = {
                    question: currentQuestion.sentence.replace("$", " _ "),
                    correct: currentQuestion.word,
                    incorrect: value
                };
                setFeedback([...feedback, result]);
            }

            if (callback) {
                await callback(isCorrect).then(() => {
                    newQuestion();
                });
            } else {
                newQuestion();
            }
        }
    }

    async function checkResultRound3(value, callback) {
      let isCorrect = true;
      if (value) {
          if (currentQuestion.word.toLowerCase() === value.toLowerCase()) {
              setCompletedQuestions([...completedQuestions, value.value]);
              //setCorrectQuestions([...correctQuestions, currentQuestion]);
              isCorrect = true;
              let multiplier = combo > 0 ? combo + 1 : 1;
              multiplier = multiplier > 5 ? 5 : multiplier;
              setScore(score + multiplier * 10);

              setCombo(combo + 1);
              if (combo > maxCombo) {
                  setMaxCombo(combo);
              }
              //setNoFeedback([...nofeedback, result]);
          } else {
              //setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
              setWrongQuestions([...wrongQuestions, currentQuestion.word]);
              isCorrect = false;
              if (combo === 0 && score >= 10) {
                  setScore(score - 10);
              } else {
                  setCombo(0);
              }

              //setFeedback([...feedback, result]);
              setColouredFeedback(true);
              setWaitTime(2);
          }
      }
  }

    //Called on click
  async function checkResultRound1(value, callback) {
    console.log(value);
    var isCorrect = true;
    if (value.correct == true) {
      setCompletedQuestions([...completedQuestions, value.value]);
      //console.log(value.value + " " + currentQuestion.word);
      //correct answer
      //setCorrectQuestions([...correctQuestions, currentQuestion]);
      let multiplier = combo > 0 ? combo + 1 : 1;
      multiplier = multiplier > 5 ? 5 : multiplier;
      setScore(score + multiplier * 10);

      if (combo < 99) {
        setCombo(combo + 1);
      }
      if (combo > maxCombo) {
        setMaxCombo(combo);
      }

      //moved this into a useeffect
      //newQuestion();
    }
    //incorrect answer
    else {
      isCorrect = false;
      setWrongQuestions([...wrongQuestions, currentQuestion.word]);
      //setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
      if (combo === 0 && score >= 10) {
        setScore(score - 10);
      } else {
        setCombo(0);
      }


      //setFeedback([...feedback, result]);
      setColouredFeedback(true);
      setWaitTime(2);
    }

    //Generates a new question
    //newQuestion();
  }

    //     set the first question
    useEffect(() => {
        console.log("USE EFFECT HAPPENS");
        console.log(questions);
        if (questions !== undefined && questions.length > 0) {
            console.log("set the first question");
            //setCurrentQuestion(questions[0]);
            newQuestion();
            setWordToSay(currentQuestion.word);
            console.log(currentQuestion);
            setLoading(false);
        }
    }, [status]);



    //when question changes play the relevant audio
    useEffect(() => {
        setWordToSay(currentQuestion.word);
        sayWord(currentQuestion.word);
        currentQuestion.word !== undefined &&
            setExtraChars(getExtraChars(currentQuestion.word.split(""), props.level));
    }, [currentQuestion]);

    function ComboImage() {
        var imageName = props.gameData.animation_path + "/Learn/";

        if (round == 1 && showCompleteScreen == false){
          imageName+= "round1.gif";
        }
        else if (round == 1 && showCompleteScreen == true){
          imageName+= "transition1.png";
        }
        else if (round == 2 && showCompleteScreen == false){
          imageName+= "round2.png"
        }
        else if (round == 2 && showCompleteScreen == true){
          imageName+= "transition2.gif"
        }
        else if (round == 3 && showCompleteScreen == false){
          imageName+= "round3.gif";
        } else if (round == 3 && showCompleteScreen == true){
          imageName+= "transition3.png";
        } else if (round == 4 && showCompleteScreen == false){
          imageName+= "round4.png";
        }

        //return <img src= {{imageName}} style={{position:"relative"}}></img>
        console.log("../../assets/" + imageName)
        return (require("../../assets/" + imageName))
    }

    useEffect(() => {
        if (waitTime > 0) {
            var waitttimerID = setInterval(() => reduceTimer(), 1000);
            return () => {
                clearInterval(waitttimerID);
            };
        } else if (waitTime != -10) {
            setColouredFeedback(false);
            newQuestion();
        }
      },[waitTime]);

      function reduceTimer() {
        console.log(waitTime);
      setWaitTime(waitTime - 1);
      }

    function MultipleButtons() {
        //console.log("CURRENT QUESTION");
        //console.log(currentQuestion);
    
        return FilteredAnswers().map(answer => (
    
          <Button
            {...console.log(answer)}
            value={<div dangerouslySetInnerHTML={answer.value} />}
            style={{ flex: 1, margin: "20px" }}
            onClick={() => checkResultRound1(answer, true)}
          >
              <div style={{ height: "80%", width: "100%" }}>
                <Textfit mode="multi" max="60" style={{ height: "80%", textAlign:"center", padding:"5px 50px" }}>
                  {answer.value}
                </Textfit>
              </div>
          </Button>
        ))
    
      }
    
      function MultipleFeedbackButtons() {
        console.log(currentQuestion);
    
        return FilteredAnswers().map(answer => (
    
          <Button
            {...console.log(answer)}
            value={<div dangerouslySetInnerHTML={answer.value} />}
            style={{ flex: 1, margin: "20px" , ...(answer.correct == true ? {border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)"} : {border: "2px solid #ea1d13",background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)"}) }}
          >
              <div style={{ height: "80%", width: "100%" }}>
                <Textfit mode="multi" max="60" style={{ height: "80%", textAlign:"center", padding:"5px 50px" }}>
                  {answer.value}
                </Textfit>
              </div>
          </Button>
        ))
    
      }

    async function onDragStart (e) {
        console.log(e);
        console.log(e.target);
        e.dataTransfer.setData("letter", e.target.value);
        e.dataTransfer.setData("letterid", e.target.id);
        console.log(e.target.value);
        //e.dataTransfer.setData("id", id);
    }

    async function onDragOver (e) {
        e.preventDefault();
        e.dataTransfer.dropEffect = "move";
    }

    async function onDrop (e) {
      //let id = ev.dataTransfer.getData("id");
      e.preventDefault();
      console.log(e);
      const data = e.dataTransfer.getData("letterid");//get id?
      console.log(data);
      e.target.innerText = data;
      e.target.setAttribute('value', data);
      console.log("checking if every letter is filled in");
      //console.log(inputLetters);
      //check if all are filled in
      var elements = document.getElementsByName("EmptyRune");
      console.log(elements);
      var allfilledin = true;
      elements.forEach(element => {
        console.log(element);
        console.log(element.getAttribute('id'));
        console.log(element.getAttribute('value'));
        console.log(element.innerHTML);
        if (element.getAttribute('value') == '#'){
          allfilledin = false;
        }
      });

      if (allfilledin){
        CheckRound2Answer();
      }
      
   }

   function CheckRound2Answer(){
     console.log("ALL FILLED IN, CHECKING ANSWER");

    var elements = document.getElementsByName("EmptyRune");
    console.log(elements);
    var allcorrect = true;

    var wordspelt = "";

    elements.forEach(element => {
      console.log(element);
      console.log(element.getAttribute('id'));
      console.log(element.getAttribute('value'));
      console.log(element.innerHTML);
      if (element.getAttribute('value') != element.getAttribute('id')){
        allcorrect = false;
      }
      wordspelt+=element.getAttribute('value');
      //blank this value
      element.innerText = "";
      element.setAttribute('value', "#");
    });

    console.log(wordspelt);
    //checkResult(wordspelt, true);

    var isCorrect = true;
    if (wordspelt == currentQuestion.word) {
        setCompletedQuestions([...completedQuestions, wordspelt]);
      //setCorrectQuestions([...correctQuestions, currentQuestion]);
      let multiplier = combo > 0 ? combo + 1 : 1;
      multiplier = multiplier > 5 ? 5 : multiplier;
      setScore(score + multiplier * 10);

      if (combo < 99) {
        setCombo(combo + 1);
      }
      if (combo > maxCombo) {
        setMaxCombo(combo);
      }

      //moved this into a useeffect
      //newQuestion();
    }
    //incorrect answer
    else {
      isCorrect = false;
      //setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
      setWrongQuestions([...completedQuestions, currentQuestion.word]);
      if (combo === 0 && score >= 10) {
        setScore(score - 10);
      } else {
        setCombo(0);
      }

      let result = {
        question: currentQuestion.word,
        correct: currentQuestion.correct,
        incorrect: wordspelt
      };

      //setFeedback([...feedback, result]);
      setColouredFeedback(true);
      setWaitTime(2);
    }

   }


      function MultipleRunes() {
        //console.log("CURRENT QUESTION");
        var letters = currentQuestion.word.split('');
        letters = shuffleArray(letters);
        
    
        return letters.map(letter => (
    
          <Rune
            value={letter}
            style={{ flex: 1, margin: "20px" }}
            draggable="true"
            onDragStart = {onDragStart}
            id ={letter}
          >
              <div style={{ height: "80%", width: "100%" }}>
                <div style={{ fontSize: "80px", height: "80%", textAlign:"center", padding:"5px 50px" }}>
                  {letter}
                </div>
              </div>
          </Rune>
        ))
      }

      function MultipleEmpty() {
        //console.log("CURRENT QUESTION");
        var letters = currentQuestion.word.split('');

        return letters.map(letter => (
    
          <EmptyRune
            name="EmptyRune"
            value="#"
            onDragOver={onDragOver}
            onDrop={onDrop}
            id={letter}
            style={{ flex: 1, margin: "10px", fontSize: "80px", textAlign:"center", padding:"5px 50px" }}
          >
          </EmptyRune>
        ))
    
      }


      function MultipleShowCorrect() {
        //console.log("CURRENT QUESTION");
        var letters = currentQuestion.word.split('');

        return letters.map(letter => (
    
          <EmptyRune
            style={{ flex: 1, margin: "10px", fontSize: "80px", textAlign:"center", padding:"5px 50px", background:"green" }}
          >
            {letter}
          </EmptyRune>
        ))
    
      }

      function FilteredAnswers() {
        if (currentQuestion.answers != undefined) {
          return currentQuestion.answers.filter(v => v.value !== "");
        }
        return currentQuestion;
      }

    //console.log(props);
    //console.log("CURRENTQUESTION");
    //console.log(currentQuestion);

    //return the sentence with it highlighted
    function ReturnSentence(){
        console.log(currentQuestion);
        if (currentQuestion.sentence != undefined){
            if (showWord){
                let sentence = currentQuestion.sentence.replace("$", "<bold style='color: green;'>"+currentQuestion.word+"</bold>");
                return sentence;
            }else{
                let blanks = "";
                for (let i = 0; i < currentQuestion.word.length; i++) {
                    blanks+= "-";
                }
                let sentence = currentQuestion.sentence.replace("$", blanks);
                return sentence;
            }
        }else{
            return "";
        }
    }

    //return the word
    function ReturnWord(){
        console.log(currentQuestion);
        if (currentQuestion.word != undefined){
            if (showWord){
                return currentQuestion.word;
            }else{
                let blanks = "";
                for (let i = 0; i < currentQuestion.word.length; i++) {
                    blanks+= "-";
                }
                return blanks;
            }
        }else{
            return "";
        }
    }

    function sayWord(word) {
    if (word != undefined && word != "") {
        word = word.toLowerCase();
        console.log("playing sound: " + word);
        try {
            // Updated to use the public folder path
             var audio = new Audio("/audio/" + word + '.mp3'); 
            audio.play();
        } catch (error) {
            var msg = new SpeechSynthesisUtterance();
            msg.text = word;
            window.speechSynthesis.speak(msg);
        }
    }
}


    return (
        <div>
            {round == 1 &&
             <LearnGame
             parent={props}
             correct={correctQuestions}
             incorrect={incorrectQuestions}
             score={score}
             defaultTimer={timer}
             questionLimit={questionMax}
             onBack={() => props.onBack()}
             loading={loading}
             feedback={feedback}
             questionFontSize="0.7em"
             restart={() => {
               setCombo(0);
               setScore(0);
               setCorrectQuestions([]);
               setIncorrectQuestions([]);
             }}
             homework_id={props.homework_id}
           >
             <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
               <Scale scaleTo={1920}>
               {showCompleteScreen == true &&
            <CompleteScreen>
                <Textfit mode="single" style={{height: "100%"}}>
                Round {round} Complete!
                </Textfit>
                <Button  onClick={() => NextRound()}>  <Textfit mode="single" style={{height: "100%"}}> Continue </Textfit></Button>
            </CompleteScreen>
            }

            {showCompleteScreen == false &&
                 <Body >
                   <div style={{ width: "80%" }}>
                     {currentQuestion != undefined ? (
                       <Container update={refresh}>
                         <div style={{ display: "flex", flexDirection: "row" }}>
                           <Question
                             type="text"
                             disabled
                             value={
                               currentQuestion.question !== undefined
                                 ? currentQuestion.question.replace("$", "?")
                                 : ""
                             }
                           ><Textfit mode="single" style={{ height: "100%" }} >
                               <div showWord={showWord} dangerouslySetInnerHTML={{ __html: ReturnSentence() }}></div> 
                             </Textfit>
                           </Question>
                         </div>

                         <div style={{ display: "flex", flexDirection: "row" }}>
                           <Question
                             type="text"
                             disabled
                           ><Textfit mode="single" style={{ height: "100%" }} >
                               <div showWord={showWord} dangerouslySetInnerHTML={{ __html: ReturnWord() }}></div> 
                             </Textfit>
                           </Question>
                           <Button style={{ fontSize: "100px", flex: 1 }} onClick={() => sayWord(currentQuestion.word)}>🔊</Button>
                         </div>

                         {showWord == false &&
                         <div
                           style={{
                             width: "100%",
                             display: "flex",
                             flexDirection: "row",
                             justifyContent: "space-between"
                           }}
                         >
                           {showColouredFeedback == false && currentQuestion.answers !== undefined &&
                             <div style={{
                               width: "100%",
                               display: "flex",
                               flexDirection: "row",
                               justifyContent: "space-between"
                             }}>
                               {MultipleButtons()}
                             </div>}
     
                             {showColouredFeedback == true && currentQuestion.answers !== undefined &&
                             <div style={{
                               width: "100%",
                               display: "flex",
                               flexDirection: "row",
                               justifyContent: "space-between"
                             }}>
                               {MultipleFeedbackButtons()}
                             </div>}
                         </div>
                        }
                       </Container>
     
                     ) : <h1>blank</h1>}
                   </div>
                 </Body>
            }
               </Scale>
             </div>
           </LearnGame>
            }

{round == 2 &&
             <LearnGame
             parent={props}
             correct={correctQuestions}
             incorrect={incorrectQuestions}
             score={score}
             defaultTimer={timer}
             questionLimit={questionMax}
             onBack={() => props.onBack()}
             loading={loading}
             feedback={feedback}
             questionFontSize="0.7em"
             restart={() => {
               setCombo(0);
               setScore(0);
               setCorrectQuestions([]);
               setIncorrectQuestions([]);
             }}
             homework_id={props.homework_id}
           >
             <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
               <Scale scaleTo={1920}>
               {showCompleteScreen == true &&
            <CompleteScreen>
                <Textfit mode="single" style={{height: "100%"}}>
                Round {round} Complete!
                </Textfit>
                <Button  onClick={() => NextRound()}>  <Textfit mode="single" style={{height: "100%"}}> Continue </Textfit></Button>
            </CompleteScreen>
            }

            {showCompleteScreen == false &&
                 <Body >
                   <div style={{ width: "80%" }}>
                     {currentQuestion != undefined ? (
                       <Container update={refresh}>
                         <div style={{ display: "flex", flexDirection: "row" }}>
                           <Question
                             type="text"
                             disabled
                             value={
                               currentQuestion.question !== undefined
                                 ? currentQuestion.question.replace("$", "?")
                                 : ""
                             }
                           ><Textfit mode="single" style={{ height: "100%" }} >
                               <div showWord={showWord} dangerouslySetInnerHTML={{ __html: ReturnSentence() }}></div> 
                             </Textfit>
                           </Question>
                           <Button style={{ fontSize: "100px", flex: 1 }} onClick={() => sayWord(currentQuestion.word)}>🔊</Button>
                         </div>
                         {showWord == true &&
                         <div style={{ display: "flex", flexDirection: "row" }}>
                           <Question
                             type="text"
                             disabled
                           ><Textfit mode="single" style={{ height: "100%" }} >
                               <div showWord={showWord} dangerouslySetInnerHTML={{ __html: ReturnWord() }}></div> 
                             </Textfit>
                           </Question>
                           
                         </div>
                          }
                          {showWord == false && showColouredFeedback == false &&
                          <div
                            update={{inputLetters}}
                          style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between"
                          }}>
                            {MultipleEmpty()}
                          </div>
                          }
                          {showColouredFeedback == true &&
                          <div
                          update={{inputLetters}}
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between"
                        }}>
                          {MultipleShowCorrect()}
                          </div>
                          }

                          {showWord == false && showColouredFeedback == false &&
                          <h2 style={{userSelect: "none", color: "grey", fontSize: "30px", textAlign: "center" }}> Drag the letters into the spaces </h2>
                          }
                          {showWord == false && showColouredFeedback == false &&
                         <div
                            update={{inputLetters}}
                           style={{
                             width: "100%",
                             display: "flex",
                             flexDirection: "row",
                             justifyContent: "space-between"
                           }}
                         >
                           {MultipleRunes()}
                         </div>
                          }

<Button style={{ fontSize: "25px", flex: 1 }} onClick={() => NextRound()}>Skip Round</Button>
                       </Container>
     
                     ) : <h1>blank</h1>}
                   </div>
                 </Body>
            }
               </Scale>
             </div>
           </LearnGame>
            }

{round == 3 &&
                    <LearnGame
                    parent={props}
                    correct={correctQuestions}
                    incorrect={incorrectQuestions}
                    score={score}
                    defaultTimer={timer}
                    questionLimit={questionMax}
                    onBack={() => props.onBack()}
                    loading={loading}
                    feedback={feedback}
                    nofeedback={nofeedback}
                    questionFontSize="0.7em"
                    custom={custom}
                    restart={() => {
                        setCombo(0);
                        setScore(0);
                        setCorrectQuestions([]);
                        setIncorrectQuestions([]);
                    }}
                    homework_id={props.homework_id}
                >
                    <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
                        <Scale scaleTo={1920}>
            {showCompleteScreen == true &&
            <CompleteScreen>
                <Textfit mode="single" style={{height: "100%"}}>
                Round {round} Complete!
                </Textfit>
                <Button  onClick={() => NextRound()}>  <Textfit mode="single" style={{height: "100%"}}> Continue </Textfit></Button>
            </CompleteScreen>
            }

                    {showCompleteScreen == false &&
                            <Body>
                                <div>
                                    <KeyboardStage3
                                        showWord={showWord}
                                        currentQuestion={currentQuestion}
                                        onSubmitted={checkResultRound3}
                                        playAudioButton={true}
                                        onPlayAudio={() => {
                                            setWordToSay(wordToSay);
                                            sayWord(wordToSay);
                                        }}
                                        additionalCharacters={extraChars}
                                    />
                                </div>
                            </Body>
                    }</Scale>
                    </div>
                </LearnGame>
            }
           {round == 4 &&
                    <PracticeGame
                    parent={props}
                    correct={correctQuestions}
                    incorrect={incorrectQuestions}
                    score={score}
                    defaultTimer={timer}
                    questionLimit={questionMax}
                    onBack={() => props.onBack()}
                    loading={loading}
                    feedback={feedback}
                    nofeedback={nofeedback}
                    questionFontSize="0.7em"
                    custom={custom}
                    restart={() => {
                        setCombo(0);
                        setScore(0);
                        setCorrectQuestions([]);
                        setIncorrectQuestions([]);
                    }}
                    homework_id={props.homework_id}
                >
                    <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
                        <Scale scaleTo={1720}>
                            <Body>
                                <div>
                                    <Keyboard
                                        currentQuestion={currentQuestion}
                                        onSubmitted={checkResult}
                                        playAudioButton={true}
                                        onPlayAudio={() => {
                                          setWordToSay(wordToSay);
                                          sayWord(wordToSay);
                                        }}
                                        additionalCharacters={extraChars}
                                    />
                                </div>
                            </Body>
                        </Scale>
                    </div>
                </PracticeGame>
            }
        </div>
    );
}

const Button = styled.div`
        text-align: center;
        width: 20%;
        height: 150px;
        margin: 5px;
        color: #fff;
        user-select: none;
        background: rgb(234, 146, 19);
        background: linear-gradient(
          0deg,
          rgba(234, 146, 19, 1) 0%,
          rgba(255, 186, 32, 1) 100%
        );
        border: 2px solid #e88f12;
        box-sizing: border-box;
        border-radius: 0.25em;
        cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin - bottom: 0;
    }
  `;

const Body = styled.div`
    width: 100%;
    height: 100%;
    background-image: url("${props => props.gameBackground}");
    background-size: cover;
    background-position: 0px -1px;
    display: flex;
    justify-content: center;
    padding-top: 100px;
`;

const Result = styled.div`
    width: 100%;
    height: 100%;
    font-size: 5em;
    text-align: center;
    border: solid 2px #683d8c;
`;

const Combo = styled.div`
    background: #4391bb;
    width: 120px;
    height: 120px;
    border-radius: 75px;
    border: solid #204b7b 4px;
    display: flex;
    flex-direction: column;
    text-align: center;
    color: #fff;
    justify-content: center;
    font-weight: 600;
    margin-left: 50px;
`;

const Container = styled.div`
          width:100%%;
          height:95%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-bottom:100px;
          `;


const CompleteScreen = styled.div`
        font-size: 100px;
        align-items: center;
        text-align: center;
        width:50%%;
        height:300px;
        background: #FFF;
        margin: 15px 25px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
          `;

const Question = styled.div`
          background: #FFF;
          width: 90%;
          height: 120px;
          line-height: 90px;
          font-size: 4em;
          margin: 15px 25px;
          text-align: center;
          border: none;
          border-radius: 10px;
          user-select: none;
        `;

const Rune = styled.div`
        text-align: center;
        width: 100px;
        height: 150px;
        margin: 5px;
        color: #fff;
        background: rgb(234, 146, 19);
        background: linear-gradient(
          0deg,
          rgba(234, 146, 19, 1) 0%,
          rgba(255, 186, 32, 1) 100%
        );
        border: 2px solid #e88f12;
        box-sizing: border-box;
        border-radius: 0.25em;
        cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin - bottom: 0;
    }
  `;

  const EmptyRune = styled.div`
        text-align: center;
        width: 100px;
        height: 150px;
        margin: 5px;
        color: #fff;
        user-select: none;
        background: rgb(234, 146, 19);
        background: linear-gradient(
          0deg,
          rgba(200, 130, 19, 1) 0%,
          rgba(220, 170, 32, 1) 100%
        );
        border: 2px solid #e88f12;
        box-sizing: border-box;
        border-radius: 0.25em;
        cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin - bottom: 0;
    }
  `;
